let set;

export default class ArcApi {
  constructor({
    name,
    store,
    config,
    method,
    version,
    callback,
    cacheable,
    encStatus,
  }) {
    this.query = "";
    this.query = "";
    this.status = "";
    this.encObj = "";
    this.name = name;
    this.response = "";
    this.store = store;
    this.method = method;
    this.config = config;
    this.version = version;
    this.callback = callback;
    this.encStatus = encStatus;
    this.cacheable = cacheable;
  }

  addApp(app) {
    if (set) {
      if (set.status) {
        this.addVars(set.val);
      } else {
        delete this.query[set.val];
      }
    }
    if (!this.query) {
      this.query = {};
    }
    if (!this.query.app) {
      this.query.app = [];
    }
    if (app) {
      this.query.app = app;
    }
  }

  addView(view) {
    if (!this.query) {
      this.query = {};
    }
    if (!this.query.view) {
      this.query.view = [];
    }
    if (view) {
      this.query.view = view;
    }
  }

  addVars(vars) {
    if (vars) {
      for (const key in vars) {
        if (vars[key]) {
          if (!this.query) {
            this.query = {};
          }
          if (this.query[key]) {
            if (Array.isArray(this.query[key])) {
              this.query[key] = [...this.query[key], ...vars[key]];
            } else if (typeof this.query[key] === "object") {
              this.query[key] = { ...this.query[key], ...vars[key] };
            }
          } else {
            this.query[key] = vars[key];
          }
        }
      }
    }
  }

  getResponse(result) {
    const { ARC, _Status: status } = result;
    if (status && status.condition && status.condition === "success") {
      if (ARC[this.config.PID] && ARC[this.config.PID].app) {
        delete ARC[this.config.PID].app["_nameSpace"];
      }
      return ARC[this.config.PID].app;
    } else {
      return status.condition;
    }
  }

  static getResponse({ result, PID, fullResult }) {
    try {
      result = JSON.parse(result);
    } catch (e) {}

    const { ARC, _Status: status } = result;

    if (fullResult) {
      return result;
    }
    if (
      status &&
      status.ARC &&
      status.ARC[PID] &&
      status.ARC[PID].app &&
      status.ARC[PID].app.status === "success"
    ) {
      return ARC[PID].app;
    } else {
      return ARC[PID] && ARC[PID].app;
    }
  }
}
